import sessionStorage from '@avalara/bat-apps-shared/helpers/sessionStorage';
import { t } from '@avalara/bat-apps-shared/i18n';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { getSalestaxDefaultText } from '../../../shared/helpers';
import conf from '../../conf';
import analytics from '../../lib/analytics';
import { getTotalCost } from '../../lib/buy-flow';
import { selectState } from '../../selectors';
import Banner from '../banner';
import ExternalLink from '../external-link';
import HelpCenterComponent from '../help-center';
import { getRenewalDate } from '../helpers/buy-flow';
import {
  ThankyouButton,
  ThankyouContent,
  ThankyouContentContainer,
  ThankyouPageWrapper,
} from '../styled/components/buy-flow';

const ThankYou = () => {
  let buttonUrl = conf.CUP_URL;
  let buttonText = 'Go to AvaTax';

  const {
    account: { connector },
    buyFlow,
  } = useSelector(selectState);

  const { product, selectedTier, salestax } = buyFlow;
  const quantity = selectedTier?.quantity || 0;
  const price = getTotalCost(buyFlow);

  // biome-ignore lint/correctness/useExhaustiveDependencies: leaving as is
  useEffect(() => {
    analytics.page('PURCHASE_COMPLETE', { connector: connector.name });
  }, []);

  const referrer = sessionStorage.get('referrer');
  if (Boolean(referrer) && typeof referrer === 'string') {
    const referrerHostname = new URL(referrer).hostname;
    if (conf.AA_URL.includes(referrerHostname) || conf.INTEGRATIONS_URL.includes(referrerHostname)) {
      buttonUrl = referrer;
      buttonText = 'Begin integration setup';
    }
  }

  return (
    <>
      <Banner
        backgroundImage={`${conf.ASSET_PATH}/assets/images/banner-background.png`}
        image={`${conf.ASSET_PATH}/assets/images/success_w.svg`}
        primaryText={`Thank you for purchasing ${product}`}
      />

      <ThankyouPageWrapper id='buy-thank-you'>
        <ThankyouContentContainer offsetRight={50}>
          <ThankyouContent>
            <p>
              {t('client.general.your-account-will-be-charged')}
              {price.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}
              {getSalestaxDefaultText(salestax)} for {quantity} transactions{connector && ` for ${connector.name}`}.
            </p>
            <p>
              {t('client.general.your-plan-will-renew-automatically-on')}
              {getRenewalDate(new Date())}
            </p>
            <ExternalLink data-ref='buy.buyflow.thankyou.button' href={buttonUrl} title={buttonText}>
              <ThankyouButton className='primary large'>{buttonText}</ThankyouButton>
            </ExternalLink>
          </ThankyouContent>

          <HelpCenterComponent />
        </ThankyouContentContainer>
      </ThankyouPageWrapper>
    </>
  );
};

export default ThankYou;
